import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ElementiAccessoriL1SectionWrapper,
  InspectionInfoScheda20Form,
} from 'components';
import {
  schemaPonteSpartitrafficoOptionsForL1,
  tipologiaSpartitrafficoOptions,
} from 'constants/selectOptions';
import { INFO } from 'pages/Inspections/config/info';
import SpartitrafficoForm from './SpartitrafficoForm';
const SpartitrafficoSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();

  const sovrastrutturaImpalcatoTableSpartitrafficoTableWatch = watch(
    `sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable`
  );

  const sovrastrutturaImpalcatoTable = watch(`sovrastrutturaImpalcatoTable`);
  //console.log(sovrastrutturaImpalcatoTable, 'sovrastrutturaImpalcatoTable');

  const mensoleTamponiCampateToCopy = sovrastrutturaImpalcatoTable?.map(
    el => el.spartitrafficoTable
  );

  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();
  const [openSchedaDifetti, setOpenSchedaDifetti] = useState(false);
  const [schedaDifettiIndex, setSchedaDifettiIndex] = useState();

  const editRowsSpartitraffico = item => {
    setValue('spartitrafficoTableValue', [item]);
    setValue('tipologiaSpartitrafficoTableValue', item.tipologiaSpartitraffico);
  };

  const handleSelectAllClickSpartitraffico = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable`
      );
      setSelected(selectedValue);
      setValue('spartitrafficoTableValue', selectedValue);
    } else {
      setSelected([]);
      setValue('spartitrafficoTableValue', []);
    }
  };

  useEffect(() => {
    setValue(
      'l1t3a2_tecnicoRilevatoreSpartitraffico',
      getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable[${schedaDifettiIndex}].tecnicoRilevatore`
      ) ||
        getValues('rilevatoreRischioStrutturale') ||
        ''
    );
    setValue(
      'l1t3a2_dataIspezioneSpartitraffico',
      getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable[${schedaDifettiIndex}].dataIspezione`
      ) ||
        getValues('dataIspezioneRischioStrutturale') ||
        null
    );
    setValue(
      'l1t3a2_noteGeneraliSpartitraffico',
      getValues(
        `sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable[${schedaDifettiIndex}].noteGenerali`
      ) || ''
    );
  }, [schedaDifettiIndex]);

  const handleSaveInspection = () => {
    const tecnicoRilevatore = getValues(
      'l1t3a2_tecnicoRilevatoreSpartitraffico'
    );
    const dataIspezione = getValues('l1t3a2_dataIspezioneSpartitraffico');

    const noteGenerali = getValues('l1t3a2_noteGeneraliSpartitraffico');
    setValue(
      `sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable[${schedaDifettiIndex}].tecnicoRilevatore`,
      tecnicoRilevatore
    );
    setValue(
      `sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable[${schedaDifettiIndex}].dataIspezione`,
      dataIspezione
    );
    setValue(
      `sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable[${schedaDifettiIndex}].noteGenerali`,
      noteGenerali
    );
  };

  const handleResetInspection = () => {
    setValue(`l1t3a2_tecnicoRilevatoreSpartitraffico`, '');
    setValue(`l1t3a2_dataIspezioneSpartitraffico`, null);
    setValue(`l1t3a2_noteGeneraliSpartitraffico`, '');
  };

  const dataSpartitrafficoConfig = {
    columns: {
      codice: { label: 'Cod.' },
      presenza: {
        label: 'Spartitraffico',
        format: schemaPonteSpartitrafficoOptionsForL1,
      },
      tipologiaSpartitraffico: {
        label: 'Tipologia',
        format: tipologiaSpartitrafficoOptions,
      },
      completamentoSchedaDifetti: { label: 'Completamento Scheda' },
      nrtotali: { label: 'NR' },
    },
  };

  const copyTableConfig = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaSpartitraffico: {
        label: 'Tipologia',
        format: tipologiaSpartitrafficoOptions,
      },
    },
  };

  useEffect(() => {
    if (schedaDifettiIndex !== undefined) {
      setOpenSchedaDifetti(true);
    }
  }, [schedaDifettiIndex]);

  return (
    <>
      <ElementiAccessoriL1SectionWrapper
        selectedIdx={selectedIdx}
        elementTitle={'spartitraffico'}
        infoDrawer={true}
        drawerTitle={INFO.impalcatoSpartitraffico.drawerTitle}
        drawerText={INFO.impalcatoSpartitraffico.drawerText}
        singleElementTitle={'spartitraffico'}
        tableWatch={sovrastrutturaImpalcatoTableSpartitrafficoTableWatch}
        tableWatchName={`sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable`}
        elementForm={
          <SpartitrafficoForm
            spartitrafficoFields={
              sovrastrutturaImpalcatoTableSpartitrafficoTableWatch || []
            }
            selected={selected}
            setSelected={setSelected}
            spartitrafficoTable={`sovrastrutturaImpalcatoTable[${selectedIdx}].spartitrafficoTable`}
            selectedIdx={selectedIdx}
          />
        }
        inspectionInfoForm={
          <InspectionInfoScheda20Form
            onSubmit={handleSaveInspection}
            onReset={handleResetInspection}
            tecnicoRilevatoreName={'l1t3a2_tecnicoRilevatoreSpartitraffico'}
            dateName={'l1t3a2_dataIspezioneSpartitraffico'}
            noteGeneraliName={'l1t3a2_noteGeneraliSpartitraffico'}
          />
        }
        tableConfig={dataSpartitrafficoConfig}
        editRows={editRowsSpartitraffico}
        selected={selected}
        setSelected={setSelected}
        handleSelectAllClick={handleSelectAllClickSpartitraffico}
        drawerMediaIndex={drawerMediaIndex}
        setDrawerMediaIndex={setDrawerMediaIndex}
        schedaDifettiIndex={schedaDifettiIndex}
        setSchedaDifettiIndex={setSchedaDifettiIndex}
        open={open}
        setOpen={setOpen}
        openSchedaDifetti={openSchedaDifetti}
        setOpenSchedaDifetti={setOpenSchedaDifetti}
        copyTableConfig={copyTableConfig}
        copyType={'tipologiaSpartitraffico'}
        tableForCopy={mensoleTamponiCampateToCopy}
      />
    </>
  );
};
SpartitrafficoSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default SpartitrafficoSection;
